<template>
  <div>
    <b-modal
      id="modal-projektabschluss"
      size="lg"
      centered
      :hide-footer="true"
      ref="projektabschlussModal"
    >
      <template #modal-title>
        <div class="magenta-title">Projektabschluss einreichen</div>
      </template>
      <div>
        <b-alert v-model="hasUnknownError" variant="danger">
          {{ unknownErrorMessage }}
        </b-alert>
        <validation-observer ref="observer" v-slot="{ passes }">
          <b-form @submit.prevent="passes(onSubmit)">
            <p>Bezugnehmend auf die Zusicherung <span v-if="eingangZusicherung">vom {{eingangZusicherung | moment("DD.MM.YYYY")}} </span>wird der Abschluss des Projekts gemeldet. Bitte kreuzen Sie das zutreffende Feld an:</p>
            <validation-provider vid="selection1">
              <b-form-radio
                :value="projektabschlussSelection[0].id"
                v-model="form.status"
                class="mb-4"
              >
                {{projektabschlussSelection[0].name}}
              </b-form-radio>
            </validation-provider>
            <validation-provider vid="selection2">
              <b-form-radio
                :value="projektabschlussSelection[1].id"
                v-model="form.status"
                class="mb-4"
              >
                {{projektabschlussSelection[1].name}} <br>
              </b-form-radio>
            </validation-provider>
            <validation-provider v-if="form.status === projektabschlussSelection[1].id" vid="iban" rules="required|max:100" v-slot="{ valid, errors, changed }">
              <b-form-textarea
                placeholder="Stichworte der Abweichungen"
                :state="onValidateField(valid, errors, changed)"
                v-model="form.area"
              ></b-form-textarea>
              <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
            </validation-provider>
            <validation-provider vid="selection3">
              <b-form-radio
                :value="projektabschlussSelection[2].id"
                v-model="form.status"
                class="my-4"
              >
                {{projektabschlussSelection[2].name}}
              </b-form-radio>
            </validation-provider>
            <hr>
            <div v-if="!kontoIsComplete && form.status !== projektabschlussSelection[2].id" class="mb-4">
              <p class="highlight-text">Ihre Bankdaten sind bei uns noch nicht hinterlegt, um die Auszahlung zu tätigen.</p>
              <b-form-checkbox
                id="conto-check"
                v-model="contoCheck"
                name="conto-check"
                :value="true"
                :unchecked-value="false"
                class="mb-4"
              >
                Ich habe das Bankdaten-Formular eingescannt und hochgeladen.
              </b-form-checkbox>
              <add-konto-data-modal :gesuchId="gesuchId" :projektabschlussModal="true" @refresh-projektabschluss-modal="getKonto"/>
              <hr>
            </div>
            <div v-if="displayHelptext">
              <p>Sie müssen Beilagen hinzufügen, um den Projektabschluss einzureichen.</p>
            </div>
            <b-button class="btn btn-green" type="submit" disabled v-if="isSubmitting">
              <b-spinner small></b-spinner>
              Projektabschluss einreichen
            </b-button>
            <b-button class="btn btn-green" type="submit" :disabled="radioButtonselected" v-else>Projektabschluss einreichen</b-button>
          </b-form>
        </validation-observer>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import { errorHandler, validateField } from '@/helpers/formHelper.js'
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import { mapGetters } from 'vuex'
  import AddKontoDataModal from '@/components/application/DigitalApplication/Modals/AddKontoDataModal.vue'

  export default {
    data: () => ({
      form: {
        status: null,
        area: null
      },
      isSubmitting: false,
      hasUnknownError: false,
      hasError: false,
      unknownErrorMessage: '',
      kontoIsComplete: false,
      contoCheck: false
    }),
    props: {
      gesuchId: {
        type: Number
      },
      gesuchKey: {
        type: String
      },
      eingangZusicherung: {
        type: String
      },
      uploadDisabled: {
        type: Boolean
      }
    },
    components: {
      ValidationProvider,
      ValidationObserver,
      AddKontoDataModal
    },
    created () {
      this.getProjektabschlussSelection()
    },
    methods: {
      onValidateField (valid, errors, changed) {
        return validateField(valid, errors, changed)
      },
      onSubmit () {
        this.isSubmitting = true
        this.hasUnknownError = false
        this.hasError = false

        if (this.form.status !== this.projektabschlussSelection[1].id) {
          this.form.area = null
        }

        const formData = {
          gesuchId: this.gesuchId,
          projektabschlussAuswahl: this.form.status,
          projektabschlussText: this.form.area,
          gesuchKey: this.gesuchKey
        }

        this.$store.dispatch('digitalApplication/GESUCH_PROJEKTABSCHLUSS_UPDATE', formData).then(res => {
          const { errors } = res

          if (errors) {
            this.isSubmitting = false
            return errorHandler(this, errors)
          }

          this.isSubmitting = false
          this.$refs.projektabschlussModal.hide()
          this.$emit('refresh-projektabschluss-application')
          this.$root.$emit('showProjektabschlussNotification')
        }).catch(err => {
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          this.isSubmitting = false
          console.error(err)
        })
      },
      async getProjektabschlussSelection () {
        this.$store.dispatch('codes/GET_CODES_PROJEKTABSCHLUSS').then(res => {
          const { errors } = res
          if (errors) {
            return errorHandler(this, errors)
          }
        }).catch(err => {
          console.error(err)
        })
      },
      getKonto () {
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('digitalApplication/GET_KONTO_BY_GESUCHID', this.gesuchId).then(res => {
          const { errors, data } = res
          if (errors) {
            return errorHandler(this, errors)
          }
          if (data) {
            if (data.konto.iban) {
              this.kontoIsComplete = true
            }
          }
        }).catch(err => {
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          console.error(err)
        })
      },
      openModal () {
        this.$refs.projektabschlussModal.show()
        this.getKonto()
      }
    },
    computed: {
      displayHelptext () {
        let displayHelpText = false
        if (this.form.status && this.form.status !== this.projektabschlussSelection[2].id && this.uploadDisabled) {
          displayHelpText = true
        } else {
          displayHelpText = false
        }
        return displayHelpText
      },
      radioButtonselected () {
        let readyToSubmit = false
        if (this.kontoIsComplete || this.contoCheck || (this.form.status && this.form.status === this.projektabschlussSelection[2].id)) {
          if (this.form.status && this.form.status === this.projektabschlussSelection[2].id) {
            readyToSubmit = true
          } else if (this.form.status && this.form.status !== this.projektabschlussSelection[2].id && this.uploadDisabled) {
            readyToSubmit = false
          } else if (this.form.status && this.form.status !== this.projektabschlussSelection[2].id && !this.uploadDisabled) {
            readyToSubmit = true
          } else {
            readyToSubmit = false
          }
        }
        return !readyToSubmit
      },
      ...mapGetters({
        projektabschlussSelection: 'codes/PROJEKTABSCHLUSS_SELECTION'
      })
    }
  }
</script>

<style lang="scss">
#modal-projektabschluss {
   padding-left: 0 !important;

  .magenta-title {
    color: $magenta;
    font-weight: $font-weight-bold;
  }
}

.icon-gray {
  background-color: $black-10;
  padding: 3px .5rem .5rem;
  border-radius: 0.5rem;
  margin-right: 0.25rem;
}

.highlight-text {
  color: $magenta;
  font-weight: bold;
}
</style>
